module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-regular"
  }, [_c('nav-1', {
    attrs: {
      "bg": 'hsl(38, 63%, 75%)'
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "workshops content-wrapper"
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('div', {
    staticClass: "two-columns vertical-centerd"
  }, [_c('div', {
    staticClass: "column mobile-order-1"
  }, [_c('h4', {
    staticClass: "gold"
  }, [_vm._v("Christmas Card Making Workshop")]), _vm._v(" "), _c('p', [_vm._v("We’re encouraging you to get personal this Yuletide with some creative card-making to send to your nearest and dearest. We’ll take you behind the scenes at our printing studio, packed with different paper stock, riso drums and colourful ink tubes. Then it’s time to experiment using a mixture of collage and mark-making techniques where you will create 20 creased A6 cards, printed in 2 colours on our risograph printers.")]), _vm._v(" "), _c('a', {
    staticClass: "gold-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo('prices')
      }
    }
  }, [_vm._v("View Options →")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "two-columns vertical-centerd"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "column mobile-order-1"
  }, [_c('h4', {
    staticClass: "gold"
  }, [_vm._v("Wrapping Paper Workshop")]), _vm._v(" "), _c('p', [_vm._v("Rubbish at buying presents? Always seem to get it wrong? Well, we can’t help you there. What we can do, however, is to make that slightly average gift look utterly spectacular. All you need is good wrapping paper. Hato Press will teach you a lesson in pattern-making so that you can design and print your own bespoke wrap. 20 folded A2 sheets of beautifully printed riso that guarantees to make that pair of cotton socks seem unusually desirable.")]), _vm._v(" "), _c('a', {
    staticClass: "gold-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo('prices')
      }
    }
  }, [_vm._v("View Options →")])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "prices content-wrapper",
    attrs: {
      "id": "prices"
    }
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('div', {
    staticClass: "two-columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "gold"
  }, [_vm._v("Prices Per Party")]), _vm._v(" "), _c('p', [_vm._v("Chose from either Christmas Card Making or Wrapping Paper Workshops.")]), _vm._v(" "), _c('h5', {
    staticClass: "gold"
  }, [_vm._v("Parties at Hato Press")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h5', {
    staticClass: "gold"
  }, [_vm._v("Hato Press comes to you")]), _vm._v(" "), _c('p', [_vm._v("Our workshop programme is also able to travel and we have delivered off-site workshops for Converse, Uniqlo and Facebook for group sizes ranging from 15–50.")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "gold-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo('contact')
      }
    }
  }, [_vm._v("Contact us →")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', {
    staticClass: "gold"
  }, [_vm._v("Post and Pre Workshop")]), _vm._v(" "), _c('p', [_vm._v("Mulled wine and Christmas related snacks are provided for parties at Hato Press, we can also order in take away for you and your team. If you feel like a sit down meal and a nice glass of wine or hot toddy we have a few recommendations for you that are only a short wonder down the road. "), _c('a', {
    staticClass: "gold-hover",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.scrollTo('places')
      }
    }
  }, [_vm._v("Read the list")]), _vm._v(" we’ve put together for you.")])])])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "christmas-intro content-wrapper"
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('h1', {
    staticClass: "gold"
  }, [_vm._v("\n          Hato Press"), _c('br'), _vm._v("\n          Christmas Parties\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "gold-light"
  }, [_vm._v("\n          For Christmas we offer special edition Risograph workshops, in the format of Christmas Card Making or Wrapping Paper workshops.\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "gold-light"
  }, [_vm._v("\n          It’s a great opportunity for your workplace christmas party that brings together learning through play methodologies, craft, mulled wine and a few ticks off of that Christmas shopping list.\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column mobile-order-0"
  }, [_c('img', {
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/Xmas-workshop_Kaneyasu_postcard_2019.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column mobile-order-0"
  }, [_c('img', {
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/Xmas-workshop_Kaneyasu_wrapping_2019.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    attrs: {
      "id": "images"
    }
  }, [_c('div', {
    staticClass: "content-text images"
  }, [_c('img', {
    staticClass: "image-intro",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/HatoPress-Beams-introduction.jpeg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image-drum",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/HatoPress-Risograph-Workshop-Christmas-Riso-Machine.jpeg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image-copy",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/HatoPress-Beams-Copying-Image.jpeg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image-artworking",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/HatoPress-Risograph-Workshop-Christmas-Artworking.jpeg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Participants: Up to 15 people, but if you’d like to book in a few more we will do our best to accomodate"), _c('br'), _vm._v("\n            Dates: Throughout November and December"), _c('br'), _vm._v("\n            Timings: 2–2.5 hours, anytime between 12–9:30pm"), _c('br'), _vm._v("\n            Minimum cost £500 +VAT up to 4 people, then £100 +VAT thereafter per person.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("If you think this option would suit you well, please get in touch at "), _c('a', {
    attrs: {
      "href": "mailto:bespoke@hatopress.net?subject=Hato%20Press%20Christmas%20Offer",
      "target": "_blank"
    }
  }, [_vm._v("bespoke@hatopress.net")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "christmas-action action content-wrapper",
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('h2', {}, [_vm._v("\n        Contact Us\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "width-50"
  }, [_vm._v("\n        Interested in one of the options, or got a question? Let us know what you're looking for. We're happy to help.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "mailto:bespoke@hatopress.net?subject=Hato%20Press%20Christmas%20Offer"
    }
  }, [_vm._v("bespoke@hatopress.net")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")]), _vm._v(" "), _c('img', {
    staticClass: "size-mid",
    attrs: {
      "src": "https://assets.hato.co/b1/assets/workshops/Xmas-workshop_Kaneyasu_riso_2019.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "places content-wrapper",
    attrs: {
      "id": "places"
    }
  }, [_c('div', {
    staticClass: "content-text"
  }, [_c('h2', {}, [_vm._v("\n        Places Around Hato Press\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "width-50"
  }, [_vm._v("\n        Feel like a sit down meal and a nice glass of wine or hot toddy before or after your visit? We have a few recommendations for you:\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "two-columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Dinner")]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.marksmanpublichouse.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("The Marksman")])]), _vm._v(" Michelin Pub of the Year. Dining Room Upstairs designed by Martino Gamper, serving hearty British Food\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://thelaughingheartlondon.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("The Laughing Heart")])]), _vm._v(" European small plates with a list of speciality wines\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.moritohackneyroad.co.uk/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Morito Hackney Road")])]), _vm._v(" sister restaurant to Moro on Exmouth Market, tapas dishes from Southern Spain to North Africa\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h4', [_vm._v("Drinks")]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.marksmanpublichouse.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("The Marksman")])]), _vm._v(" Michelin Pub of the Year. Dining Room Upstairs designed by Martino Gamper, serving hearty British Food\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.royaloaklondon.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("The Royal Oak")])]), _vm._v(" local gastropub with upstairs dining room\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.sagerandwilde.com/hackney-road/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Sager + Wilde")])]), _vm._v(" local wine bar\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "place"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://sebrightarms.com/",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Sebright Arms")])]), _vm._v(" local pub with live music\n                ")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action content-text"
  }, [_c('h2', {}, [_vm._v("\n        Get in touch to learn more about our regular and bespoke workshops, or any general enquiries on workshops.\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "mailto:learn@hatopress.net"
    }
  }, [_vm._v("learn@hatopress.net")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cf93569","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChristmasWorkshops.vue
// module id = 206
// module chunks = 1